var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "check-list" },
    [
      _vm.loading
        ? _vm._l(_vm.items, function(item) {
            return _c("CompassSkeleton", {
              key: item.id,
              attrs: { size: "x-large" }
            })
          })
        : _vm._l(_vm.items, function(item) {
            return _c(
              "CheckListItem",
              _vm._b({ key: item.id }, "CheckListItem", item, false)
            )
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }